var _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#f5f5f5",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-8.32 -8.32 48.64 48.64",
    xmlSpace: "preserve",
    width: "237px",
    height: "237px",
    stroke: "#f5f5f5",
    strokeWidth: 0.00032,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-8.32, -8.32), scale(3.04)",
    fill: "#3980d5",
    d: "M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.192
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "speech",
    d: "M10.004,11.001L10.778,11L8.341,4.867H7.672l-2.439,6.134h0.775L6.661,9.36h2.691L10.004,11.001z M6.947,8.64 l1.06-2.666L9.066,8.64H6.947z M26.354,31h-0.721c0-4.349-2.937-8.173-7.142-9.3c-0.144-0.038-0.248-0.159-0.265-0.307 c-0.018-0.146,0.058-0.289,0.188-0.358c1.677-0.897,2.719-2.636,2.719-4.535c0-2.835-2.306-5.141-5.14-5.141 c-2.835,0-5.141,2.306-5.141,5.141c0,1.899,1.042,3.636,2.72,4.535c0.13,0.069,0.205,0.212,0.188,0.358 c-0.017,0.147-0.122,0.269-0.264,0.307C9.29,22.827,6.353,26.651,6.353,31h-0.72c0-4.407,2.806-8.312,6.914-9.76 c-1.507-1.094-2.415-2.847-2.415-4.74c0-3.232,2.629-5.861,5.861-5.861c3.231,0,5.86,2.629,5.86,5.861 c0,1.893-0.908,3.646-2.414,4.74C23.549,22.688,26.354,26.593,26.354,31z M7.678,18.161L5.777,14.36H3 c-1.301,0-2.36-1.059-2.36-2.36V5c0-1.301,1.059-2.36,2.36-2.36h10c1.301,0,2.36,1.059,2.36,2.36v4h-0.72V5 c0-0.904-0.736-1.64-1.64-1.64H3C2.096,3.36,1.36,4.096,1.36,5v7c0,0.904,0.736,1.64,1.64,1.64h3c0.136,0,0.261,0.077,0.322,0.199 l2,4L7.678,18.161z M24.322,16.161l-0.645-0.322l2-4c0.062-0.122,0.186-0.199,0.322-0.199h3c0.904,0,1.64-0.736,1.64-1.64V3 c0-0.904-0.735-1.64-1.64-1.64H19c-0.904,0-1.64,0.736-1.64,1.64v4h-0.72V3c0-1.301,1.058-2.36,2.36-2.36h10 c1.302,0,2.36,1.059,2.36,2.36v7c0,1.301-1.059,2.36-2.36,2.36h-2.777L24.322,16.161z M27.006,9.36 c-1.228,0-2.225-0.389-2.994-0.948c-0.776,0.63-1.784,0.948-3.006,0.948V8.64c0.99,0,1.81-0.236,2.442-0.704 c-0.769-0.749-1.225-1.655-1.376-2.362l0.703-0.151c0.138,0.635,0.549,1.394,1.205,2.015c0.867-1.021,1.006-2.439,1.021-3.078 h-3.995V3.64h2.64V2.498h0.721v1.143h2.64v0.72h-1.282c-0.014,0.727-0.167,2.325-1.182,3.53c0.658,0.448,1.486,0.75,2.464,0.75V9.36 H27.006z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechSvgrepoCom1);
export default __webpack_public_path__ + "static/media/speech-svgrepo-com (1).1268993a31bcf39dc1f6e6f3eb49e3be.svg";
export { ForwardRef as ReactComponent };